import { render, staticRenderFns } from "./fivesale.vue?vue&type=template&id=a8722b72"
import script from "./fivesale.vue?vue&type=script&lang=js"
export * from "./fivesale.vue?vue&type=script&lang=js"
import style0 from "./fivesale.vue?vue&type=style&index=0&id=a8722b72&prod&lang=css"
import style1 from "./fivesale.vue?vue&type=style&index=1&id=a8722b72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports